import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { RecipientsField, recipientsLabel } from './RecipientsField.tsx';
import FormField from '../../core/components/FormField.tsx';
import { displayName } from '../utils/displayName.ts';

export { displayName };

interface ProjectSharingFieldsProps {
    // picker values ("team:<id>", "user:<id>"), see RecipientsField
    value: string[];
    onValueChange: (value: string[]) => void;
    // a reader (member, not manager) only sees who the project is shared with
    isReadOnly?: boolean;
    shared?: { team?: { name: string } | null; members?: any[] | null } | null;
}

/** Sharing never reaches further than one of the sharer's own teams: a team and/or named people from those teams,
 *  picked with the same field as a shared chat. Empty means the project stays with its owner. */
export const ProjectSharingFields = ({
    value,
    onValueChange,
    isReadOnly = false,
    shared = null,
}: ProjectSharingFieldsProps) => {
    const { t } = useTranslation('chat');

    if (isReadOnly) {
        const label = recipientsLabel(shared?.team, shared?.members, t);
        return (
            <FormField label={t('projects.sharing.label')}>
                <span className="text-sm text-content-strong">{label || t('projects.sharing.onlyYou')}</span>
            </FormField>
        );
    }
    return (
        <FormField
            label={t('projects.sharing.label')}
            helpText={t(value.length === 0 ? 'projects.sharing.onlyYou' : 'projects.sharing.canUse')}
        >
            <RecipientsField
                value={value}
                onValueChange={onValueChange}
                placeholder={t('projects.sharing.placeholder')}
            />
        </FormField>
    );
};
